import { classnames } from '@aibees/shared/utils';
import { Grid } from '@mui/material';
import { memo } from 'react';
import { BillingAddress } from '../billing-address';
import { EmailSettings } from '../email-settings';
import * as Styled from './styles';
import * as SX from './sx';
import type { BillingInformationProps as Props } from './types';

export const BillingInformation = memo(({ className }: Props) => {
  return (
    <Styled.Wrapper
      className={classnames('BillingInformation', className)}
      sx={SX.root}
    >
      <Grid container spacing={0.5}>
        <Grid item xs={12} md={6}>
          <EmailSettings />
        </Grid>
        <Grid item xs={12} md={6}>
          <BillingAddress />
        </Grid>
      </Grid>
    </Styled.Wrapper>
  );
});

BillingInformation.displayName = 'BillingInformation';
